"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-screen bg-[#0b0c10] text-white">
      <div className="mx-auto max-w-2xl px-6 py-24 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-[#c9a24b]">Global AI Author System</p>
        <h1 className="mt-4 text-3xl font-semibold">Something went wrong</h1>
        <p className="mt-3 text-sm text-slate-400">
          {error?.message || "An unexpected error occurred. Please try again."}
        </p>
        <button
          className="mt-6 rounded-xl bg-[#c9a24b] px-4 py-2 text-sm font-semibold text-black"
          onClick={reset}
          type="button"
        >
          Retry
        </button>
      </div>
    </div>
  );
}
